export default {
  'Choose File': 'फाइल चुनें',
  'Please paste a URL': 'कृपया URL पेस्ट करें',
  'Loading': 'लोड हो रहा है',
  'Analyzing': 'विश्लेषण हो रहा है',
  'Try a sample': 'सैंपल आजमाएं',
  'Sorry, error occurs when analyzing the URL.': 'माफ़ करें, URL का विश्लेषण करते समय त्रुटि आ गयी थी।',
}